import React, { useContext } from 'react';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { useTranslation } from 'react-i18next';
import { CareUserContext } from './provider/careUserContext';
import { commonPath, customColumnPath } from './fieldPath';
import { checkIsNumber } from '../../../Components/helper';
import RenderOptionsItem from './RenderOptionsItems';

export default function ManualColumnSection({ columnEle, columnIndex, handleChange }) {
  const { t } = useTranslation('common');
  const { state } = useContext(CareUserContext);

  const changeStatusArray = (e, keyIn, keyName) => {
    handleChange(e.target.value, customColumnPath(columnIndex, keyIn, keyName).STATUS_COLOURS, columnIndex);
  };

  const renderOptionsList = (option, optionIndex) => {
    return (
      <RenderOptionsItem
        column={option}
        index={optionIndex}
        parentIndex={columnIndex}
        id={`${state?.selectedTabId}_${columnIndex}_${option?.name}_${optionIndex}`}
        columnEle={columnEle}
        wholeArry={columnEle?.options}
      />
    );
  };

  return (
    <>
      {['Checkbox', 'Dropdown', 'Multi_select_Dropdown', 'Radio_button'].includes(columnEle?.columnType?.key) && (
        <DndProvider backend={HTML5Backend} key={`option_${columnEle?._id}_${columnEle?.name}_${columnIndex}`}>
          <label htmlFor="options" className="asterisk-req f-16 font-heavy mb-2">
            {t('PIM_MODULE.COLUMN_MODAL.MANUAL_COLUMN_SECTION.MANUAL_TYPE_OPTIONS')} <span>*</span>
          </label>
          {columnEle?.options?.map((optionEle, optionIndex) => {
            return renderOptionsList(optionEle, optionIndex);
          })}
        </DndProvider>
      )}
      {columnEle?.columnType?.key === 'Status' && (
        <div className="input-group care-status-option fixed-label">
          {/* <button
            type="button"
            className="btn p-0 d-inline-flex w-100 justify-content-center align-items-center mb-16"
            value={columnEle?.isStatusEditTrue}
            onClick={() => handleChange(!columnEle?.isStatusEditTrue, commonPath(columnIndex, "isStatusEditTrue").COMMON, columnIndex)}
          >
            <i className="icon-Edit-1 f-20 " />
            <span className="font-heavy ml-8 f-16 ">{t("PIM_MODULE.COLUMN_MODAL.MANUAL_COLUMN_SECTION.EDIT_COLOR")}</span>
          </button> */}
          {columnEle?.statusColoursOptions?.map((stat, keyIn) => {
            return (
              <button
                className="status-color-option color-content p-0 line-normal btn"
                aria-label="status-color-option "
                type="button"
                key={keyIn}
                onClick={() => handleChange(stat, commonPath(columnIndex, 'status').COMMON, columnIndex)}
              >
                <input
                  type="color"
                  className="form-control color-content-input "
                  value={stat?.colourHexCode}
                  onChange={(e) => changeStatusArray(e, keyIn, 'colourHexCode')}
                  style={
                    columnEle?.status?.colourHexCode === stat?.colourHexCode
                      ? {
                          border: '4px solid #1E90FF',
                        }
                      : {}
                  }
                />

                <input
                  type="text"
                  className="text-color-content f-16 font-heavy"
                  value={stat?.colourName}
                  placeholder={t('PIM_MODULE.COLUMN_MODAL.MANUAL_COLUMN_SECTION.ADD_COLOUR_NAME')}
                  onChange={(e) => changeStatusArray(e, keyIn, 'colourName')}
                  readOnly={!columnEle?.isStatusEditTrue}
                />
              </button>
            );
          })}
          {columnEle?.hasError && !columnEle?.status && (
            <span className="error-message ">{t('PIM_MODULE.COLUMN_MODAL.MANUAL_COLUMN_SECTION.SELECT_STATUS')}</span>
          )}
        </div>
      )}
      {columnEle?.columnType?.key === 'Textbox' && (
        <div className="input-group common-input-control fixed-label">
          <input
            type="text"
            className="form-control col-input"
            value={columnEle?.characterLimit}
            placeholder={t('PIM_MODULE.COLUMN_MODAL.MANUAL_COLUMN_SECTION.ADD_CHARACTER_UNIT')}
            onChange={(e) => {
              if (checkIsNumber(e?.target?.value)) {
                handleChange(e?.target?.value, commonPath(columnIndex, 'characterLimit').COMMON, columnIndex);
              }
            }}
          />
          {columnEle?.hasError && !columnEle?.characterLimit && (
            <span className="error-message ">{t('PIM_MODULE.COLUMN_MODAL.MANUAL_COLUMN_SECTION.CHARACTER_LIMIT_REQUIRED')}</span>
          )}
        </div>
      )}
    </>
  );
}
